package dev.lingvo.site.components.studio.editor

import dev.lingvo.shared.SourceViewDto
import dev.lingvo.shared.TranslationState
import dev.lingvo.shared.screenshots.doc.TextLayer
import dev.lingvo.shared.screenshots.text.FitResult
import dev.lingvo.shared.screenshots.text.FontStack

/** A captured keys-API identity prevents locale switches from retargeting an in-flight save or Undo. */
internal data class CaptionSnapshot(
    val project: String, val keyId: String, val key: String, val locale: String, val language: String,
    val sourceLocale: String, val value: String, val draft: String = value,
    val state: TranslationState, val sourceView: SourceViewDto?, val targetRevision: String?,
    val canWrite: Boolean, val affectedTranslations: Int, val layer: TextLayer,
    val font: FontStack, val sourceText: String? = null, val fit: FitResult? = null, val saving: Boolean = false, val error: String? = null,
) {
    val editable: Boolean get() = canWrite && sourceView != null && !saving
}

/** Explicit keys writes carry source and target claims rather than silently overwriting another editor. */
internal fun interface CaptionKeysPort {
    suspend fun write(snapshot: CaptionSnapshot, value: String): CaptionSnapshot
}

/** Fitting is shared by inline and properties editing; the stage injects its real renderer fitter. */
internal fun interface CaptionFitPort {
    fun fit(text: String, locale: String, layer: TextLayer): FitResult
}

